export default (...args) => args.find((arg) => arg !== undefined && arg !== null)
